// Comportamiento del tema Comixstore. Sin dependencias: cada parte se activa solo
// si su HTML está en la página, y los efectos respetan "reducir movimiento".

const movimientoReducido = matchMedia('(prefers-reduced-motion: reduce)');
const punteroFino = matchMedia('(hover: hover) and (pointer: fine)');

// Cabecera: avisos que rotan (con pausa), se compacta al bajar y se esconde si sigues bajando, menú por pilares con
// las portadas que se piden al abrirlo, menú del celular por niveles, buscador con «/» y ⌘K, y Mis series.
class CabeceraTienda extends HTMLElement {
  connectedCallback() {
    this.seccion = this.closest('.seccion-cabecera') ?? this;
    this.cache = new Map();
    this.config = {};
    this.leerPilares();
    this.activarAvisos();
    this.activarDesplazamiento();
    this.activarMega();
    this.activarCajon();
    this.activarPaleta();
    this.activarMisSeries();
    this.activarRotativo();
  }

  // Pide una sección liviana (menu-portadas, menu-llegan, serie-resumen) y devuelve su raíz; cada pedido se hace una vez.
  traer(url, seccion, selector, ordenar = true) {
    const clave = `${url}|${seccion}`;
    if (!this.cache.has(clave)) {
      const destino = new URL(url, location.origin);
      destino.searchParams.set('section_id', seccion);
      if (ordenar) destino.searchParams.set('sort_by', 'created-descending');
      this.cache.set(clave, fetch(destino)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector(selector))
        .catch(() => null));
    }
    return this.cache.get(clave);
  }

  // Los bloques «Pilar del menú» dan clima, color, texto y atajos al panel del enlace con el mismo nombre.
  leerPilares() {
    this.querySelectorAll('[data-pilar-config]').forEach((plantilla) => {
      const clave = plantilla.dataset.pilarConfig;
      const contenido = plantilla.content;
      const atajos = [...contenido.querySelectorAll('[data-pilar-atajo]')];
      this.config[clave] = {
        texto: contenido.querySelector('[data-pilar-texto]')?.textContent.trim() ?? '',
        llegan: plantilla.dataset.llegan !== 'false',
      };
      const boton = this.querySelector(`.nav__item[data-pilar="${clave}"]`);
      if (boton && plantilla.dataset.color) boton.style.setProperty('--punto', plantilla.dataset.color);
      const mega = this.querySelector(`[data-mega="${clave}"]`);
      if (mega) {
        mega.classList.replace('clima-biblioteca', `clima-${plantilla.dataset.clima || 'biblioteca'}`);
        const texto = mega.querySelector('[data-vista-texto]');
        if (texto) texto.textContent = this.config[clave].texto;
        if (atajos.length) {
          const fila = mega.querySelector('.mega__rejilla--doble [data-atajos-fila]');
          if (fila) {
            atajos.forEach((a) => fila.append(Object.assign(document.createElement('a'), { className: 'chip', href: a.href, textContent: a.querySelector('strong')?.textContent ?? '' })));
            fila.hidden = false;
          } else {
            mega.querySelector('[data-atajos-lista]')?.append(...atajos.map((a) => a.cloneNode(true)));
            mega.querySelector('[data-atajos]')?.removeAttribute('hidden');
          }
        }
      }
      const nivel = this.querySelector(`[data-nivel="${clave}"]`);
      if (nivel) {
        const pequeno = nivel.querySelector('[data-cajon-texto]');
        if (pequeno) pequeno.textContent = this.config[clave].texto;
        if (atajos.length) {
          nivel.querySelector('[data-cajon-atajos] [data-atajos-lista]')?.append(...atajos.map((a) => a.cloneNode(true)));
          nivel.querySelector('[data-cajon-atajos]')?.removeAttribute('hidden');
        }
      }
    });
  }

  activarAvisos() {
    const caja = this.querySelector('.avisos');
    const items = caja ? [...caja.querySelectorAll('.avisos__item')] : [];
    if (items.length < 2) return;
    let actual = 0;
    let pausa = false;
    caja.dataset.listo = '';
    // Los avisos que no se ven quedan inertes: sus enlaces no reciben el foco
    items.forEach((item, i) => {
      item.dataset.estado = i ? '' : 'activo';
      item.inert = Boolean(i);
    });
    setInterval(() => {
      if (pausa || document.hidden) return;
      const sale = items[actual];
      sale.dataset.estado = 'sale';
      sale.inert = true;
      setTimeout(() => { if (sale.dataset.estado === 'sale') sale.dataset.estado = ''; }, 700);
      actual = (actual + 1) % items.length;
      items[actual].dataset.estado = 'activo';
      items[actual].inert = false;
    }, 4500);
    const boton = caja.querySelector('[data-avisos-pausa]');
    boton?.addEventListener('click', () => {
      pausa = !pausa;
      boton.setAttribute('aria-pressed', String(pausa));
      boton.setAttribute('aria-label', pausa ? boton.dataset.textoReanudar : boton.dataset.textoPausar);
      boton.querySelector('[data-icono-pausa]').hidden = pausa;
      boton.querySelector('[data-icono-reanudar]').hidden = !pausa;
    });
  }

  activarDesplazamiento() {
    let ultimo = scrollY;
    let pendiente = false;
    const raiz = document.documentElement;
    // Alto visible: compacta, la franja de avisos queda fuera de la pantalla (la cabecera se desplaza, no se achica)
    const avisos = this.seccion.querySelector('.avisos');
    const medir = () => raiz.style.setProperty('--alto-cabecera', this.seccion.hasAttribute('data-oculta') ? '0px'
      : `${this.seccion.offsetHeight - (this.seccion.hasAttribute('data-compacta') && avisos ? avisos.offsetHeight : 0)}px`);
    const revisar = () => {
      pendiente = false;
      const y = scrollY;
      this.seccion.toggleAttribute('data-compacta', y > 40);
      const baja = y > ultimo + 6;
      const sube = y < ultimo - 6;
      const ocupada = this.megaAbierto || this.querySelector('dialog[open], :popover-open');
      if (baja && y > 480 && !ocupada) this.seccion.setAttribute('data-oculta', '');
      else if (sube || y <= 480) this.seccion.removeAttribute('data-oculta');
      if (baja || sube) ultimo = y;
      medir();
    };
    addEventListener('scroll', () => {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(revisar);
    }, { passive: true });
    this.seccion.addEventListener('transitionend', medir);
    medir();
  }

  mostrarCabecera() {
    this.seccion.style.transition = 'none';
    this.seccion.removeAttribute('data-oculta');
    void this.seccion.offsetWidth;
    this.seccion.style.transition = '';
  }

  activarMega() {
    const nav = this.querySelector('.cabecera__nav');
    if (!nav) return;
    const linea = nav.querySelector('.nav__linea');
    const velo = this.seccion.querySelector('[data-velo]') ?? document.createElement('div');
    // El velo vive en el body: la cabecera se desplaza con transform al bajar, y un fixed dentro de ella quedaría
    // cubriendo solo la cabecera. Al re-renderizar la sección (editor de temas) se reemplaza el anterior.
    document.querySelectorAll('body > .velo-menu').forEach((v) => v !== velo && v.remove());
    document.body.append(velo);
    const barra = this.querySelector('.cabecera__barra');
    const items = [...nav.querySelectorAll('.nav__item')];
    let cierre = 0;
    let apertura = 0;
    const moverLinea = (el) => {
      if (!linea) return;
      if (!el) { linea.style.opacity = 0; return; }
      const r = el.getBoundingClientRect();
      const n = nav.getBoundingClientRect();
      linea.style.inlineSize = `${r.width - 24}px`;
      linea.style.transform = `translateX(${r.left - n.left + nav.scrollLeft + 12}px)`;
      linea.style.opacity = 1;
    };
    const panelDe = (boton) => this.querySelector(`#${boton.getAttribute('aria-controls')}`);
    const cerrar = (volverFoco, cambio) => {
      const boton = this.megaAbierto;
      if (!boton) return;
      const panel = panelDe(boton);
      boton.setAttribute('aria-expanded', 'false');
      if (cambio) {
        panel.style.transition = 'none';
        delete panel.dataset.abierto;
        void panel.offsetWidth;
        panel.style.transition = '';
      } else {
        delete panel.dataset.abierto;
        delete velo.dataset.visible;
        moverLinea(null);
      }
      this.megaAbierto = null;
      if (volverFoco) boton.focus();
    };
    const abrir = (boton, foco) => {
      clearTimeout(cierre);
      const panel = panelDe(boton);
      if (this.megaAbierto === boton) {
        if (foco) panel.querySelector('.mega__fila')?.focus();
        return;
      }
      if (this.megaAbierto) cerrar(false, true);
      boton.setAttribute('aria-expanded', 'true');
      panel.dataset.abierto = '';
      velo.dataset.visible = '';
      this.megaAbierto = boton;
      moverLinea(boton);
      this.cargarMega(panel);
      if (foco) setTimeout(() => panel.querySelector('.mega__fila')?.focus(), 60);
    };
    items.forEach((item) => {
      item.addEventListener('pointerenter', () => {
        moverLinea(item);
        if (!punteroFino.matches) return;
        clearTimeout(apertura);
        clearTimeout(cierre);
        if (item.dataset.pilar) {
          this.cargarMega(panelDe(item));
          apertura = setTimeout(() => abrir(item), this.megaAbierto ? 0 : 110);
        } else apertura = setTimeout(() => cerrar(), 140);
      });
      if (!item.dataset.pilar) return;
      item.addEventListener('click', () => (this.megaAbierto === item ? cerrar() : abrir(item)));
      item.addEventListener('keydown', (evento) => {
        if (evento.key !== 'ArrowDown') return;
        evento.preventDefault();
        abrir(item, true);
      });
    });
    nav.addEventListener('pointerleave', () => { clearTimeout(apertura); moverLinea(this.megaAbierto); });
    const zona = [barra, ...this.querySelectorAll('.mega')];
    zona.forEach((el) => {
      el.addEventListener('pointerleave', (evento) => {
        if (evento.pointerType !== 'mouse' || zona.some((z) => z.contains(evento.relatedTarget))) return;
        cierre = setTimeout(() => cerrar(), 260);
      });
      el.addEventListener('pointerenter', () => clearTimeout(cierre));
    });
    document.addEventListener('keydown', (evento) => { if (evento.key === 'Escape' && this.megaAbierto) cerrar(true); });
    document.addEventListener('pointerdown', (evento) => {
      if (this.megaAbierto && !zona.some((z) => z.contains(evento.target))) cerrar();
    });
    this.addEventListener('focusout', (evento) => {
      if (this.megaAbierto && evento.relatedTarget && !zona.some((z) => z.contains(evento.relatedTarget))) cerrar();
    });
    // La vista previa cambia con la categoría que recorres
    this.querySelectorAll('.mega__fila[data-cat]').forEach((fila) => {
      const mostrar = () => this.mostrarVista(fila.closest('.mega'), fila);
      fila.addEventListener('pointerenter', mostrar);
      fila.addEventListener('focus', mostrar);
    });
    // Al cerrarse, el panel vuelve a mostrar el pilar completo
    this.querySelectorAll('.mega').forEach((panel) => panel.addEventListener('transitionend', (evento) => {
      if (evento.target !== panel || panel.hasAttribute('data-abierto')) return;
      panel.querySelectorAll('.mega__fila[data-activa]').forEach((f) => f.removeAttribute('data-activa'));
      this.mostrarVista(panel, null, true);
    }));
  }

  async cargarMega(panel) {
    if (!panel || panel.dataset.cargado) return;
    panel.dataset.cargado = '';
    this.mostrarVista(panel, null, true);
    // Se adelantan las portadas de cada categoría para que el cambio al recorrerlas sea inmediato
    panel.querySelectorAll('.mega__fila[data-cat]').forEach((fila) => this.traer(fila.dataset.cat, 'menu-portadas', '#MenuPortadas'));
    const clave = panel.dataset.mega;
    if (this.config[clave]?.llegan === false) return;
    const llegan = await this.traer(panel.dataset.url, 'menu-llegan', '#MenuLlegan');
    const lista = llegan?.querySelector('.tira');
    if (!lista?.children.length) return;
    const tira = panel.querySelector('[data-tira]');
    tira.querySelector('[data-tira-titulo]').textContent = llegan.dataset.titulo;
    tira.querySelector('[data-tira-lista]').replaceChildren(lista);
    tira.hidden = false;
  }

  async mostrarVista(panel, fila, esPilar = false) {
    const vista = panel?.querySelector('[data-vista]');
    if (!vista) return;
    if (fila) {
      if (fila.hasAttribute('data-activa')) return;
      panel.querySelectorAll('.mega__fila[data-activa]').forEach((f) => f.removeAttribute('data-activa'));
      fila.setAttribute('data-activa', '');
    }
    const url = esPilar ? vista.dataset.pilarUrl : fila.dataset.cat;
    const turno = (vista.turno = (vista.turno ?? 0) + 1);
    vista.dataset.cambiando = '';
    const [datos] = await Promise.all([
      this.traer(url, 'menu-portadas', '#MenuPortadas'),
      new Promise((ok) => setTimeout(ok, movimientoReducido.matches ? 0 : 160)),
    ]);
    if (turno !== vista.turno) return;
    const ir = vista.querySelector('[data-vista-ir]');
    vista.querySelector('[data-vista-abanico]').replaceChildren(...(datos?.querySelector('[data-menu-abanico]')?.cloneNode(true).children ?? []));
    vista.querySelector('[data-vista-titulo]').textContent = esPilar ? this.querySelector(`.nav__item[data-pilar="${panel.dataset.mega}"]`)?.textContent.trim() ?? '' : fila.querySelector('span')?.textContent ?? '';
    vista.querySelector('[data-vista-texto]').textContent = (esPilar && this.config[panel.dataset.mega]?.texto) || datos?.querySelector('[data-menu-texto]')?.textContent.trim() || '';
    if (datos?.dataset.cuenta) vista.querySelector('[data-vista-cuenta]').textContent = datos.dataset.cuenta;
    ir.href = url;
    ir.textContent = esPilar ? ir.dataset.textoTodo : ir.dataset.textoCategoria;
    requestAnimationFrame(() => requestAnimationFrame(() => delete vista.dataset.cambiando));
  }

  activarCajon() {
    const cajon = this.querySelector('[data-cajon]');
    const abrir = this.querySelector('[data-abrir-cajon]');
    if (!cajon || !abrir) return;
    const niveles = [...cajon.querySelectorAll('.cajon__nivel')];
    let actual = 'raiz';
    const portadas = async (destino, url, cantidad) => {
      if (destino.dataset.cargado) return;
      destino.dataset.cargado = '';
      const datos = await this.traer(url, 'menu-portadas', '#MenuPortadas');
      const imagenes = [...(datos?.querySelector('[data-menu-abanico]')?.children ?? [])].slice(0, cantidad).map((img) => img.cloneNode(true));
      destino.replaceChildren(...imagenes);
    };
    const irNivel = (id, desde) => {
      const destino = niveles.find((n) => n.dataset.nivel === id);
      niveles.forEach((n) => {
        if (n === destino) {
          delete n.dataset.fuera;
          n.inert = false;
          n.scrollTop = 0;
        } else {
          n.dataset.fuera = n.dataset.nivel === 'raiz' ? 'izquierda' : 'derecha';
          n.inert = true;
        }
      });
      if (id !== 'raiz') {
        destino.querySelectorAll('[data-mini]').forEach((mini) => portadas(mini, mini.dataset.mini, 3));
        this.cargarLleganCajon(destino);
      }
      setTimeout(() => destino.querySelector(id === 'raiz' ? `[data-ir="${desde}"]` : '[data-volver]')?.focus(), movimientoReducido.matches ? 0 : 200);
    };
    abrir.addEventListener('click', () => {
      irNivel('raiz');
      cajon.showModal();
      abrir.setAttribute('aria-expanded', 'true');
      cajon.querySelectorAll('[data-pilar-portadas]').forEach((destino) => portadas(destino, destino.closest('[data-portadas-de]').dataset.portadasDe, 3));
    });
    cajon.addEventListener('close', () => {
      abrir.setAttribute('aria-expanded', 'false');
      abrir.focus();
    });
    cajon.addEventListener('click', (evento) => {
      if (evento.target === cajon || evento.target.closest('[data-cerrar-cajon]')) { cajon.close(); return; }
      const ir = evento.target.closest('[data-ir]');
      if (ir) { actual = ir.dataset.ir; irNivel(actual); return; }
      if (evento.target.closest('[data-volver]')) irNivel('raiz', actual);
    });
  }

  async cargarLleganCajon(nivel) {
    const caja = nivel.querySelector('[data-cajon-llegan]');
    if (!caja || caja.dataset.cargado || this.config[nivel.dataset.nivel]?.llegan === false) return;
    caja.dataset.cargado = '';
    const llegan = await this.traer(nivel.dataset.megaUrl, 'menu-llegan', '#MenuLlegan');
    const lista = llegan?.querySelector('.tira');
    if (!lista?.children.length) return;
    caja.querySelector('[data-tira-titulo]').textContent = llegan.dataset.titulo;
    caja.querySelector('[data-tira-lista]').replaceChildren(lista.cloneNode(true));
    caja.hidden = false;
  }

  activarPaleta() {
    const paleta = this.querySelector('[data-paleta]');
    if (!paleta) return;
    const campo = paleta.querySelector('[data-paleta-campo]');
    const inicio = paleta.querySelector('[data-paleta-inicio]');
    const resultados = paleta.querySelector('[data-paleta-resultados]');
    const estado = paleta.querySelector('[data-predictiva-estado]');
    const claveRecientes = 'comixstore:busquedas';
    let activa = -1;
    let temporizador = 0;
    let peticion = null;
    const leerRecientes = () => { try { return JSON.parse(localStorage.getItem(claveRecientes) || '[]'); } catch { return []; } };
    const guardarReciente = (texto) => {
      const limpio = texto.trim();
      if (limpio.length < 2) return;
      try { localStorage.setItem(claveRecientes, JSON.stringify([limpio, ...leerRecientes().filter((t) => t !== limpio)].slice(0, 5))); } catch { /* sin almacenamiento */ }
    };
    const opciones = () => [...paleta.querySelectorAll('[role="option"]')].filter((o) => !o.closest('[hidden]'));
    const marcar = (i) => {
      const lista = opciones();
      activa = lista.length ? (i + lista.length) % lista.length : -1;
      lista.forEach((o, k) => o.setAttribute('aria-selected', String(k === activa)));
      if (activa >= 0) {
        campo.setAttribute('aria-activedescendant', lista[activa].id);
        lista[activa].scrollIntoView({ block: 'nearest' });
      } else campo.removeAttribute('aria-activedescendant');
    };
    const pintarInicio = () => {
      const recientes = leerRecientes();
      const caja = inicio.querySelector('[data-paleta-recientes]');
      caja.hidden = !recientes.length;
      caja.querySelector('[data-paleta-recientes-lista]').replaceChildren(...recientes.map((texto, i) => {
        const li = Object.assign(document.createElement('li'), { className: 'predictiva__opcion', id: `PaletaReciente-${i}` });
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        const a = Object.assign(document.createElement('a'), { href: `${this.dataset.buscar}?q=${encodeURIComponent(texto)}&type=product`, tabIndex: -1 });
        a.append(Object.assign(document.createElement('span'), { textContent: texto }));
        li.append(a);
        return li;
      }));
    };
    const buscar = async () => {
      const termino = campo.value.trim();
      if (termino.length < 2) {
        resultados.replaceChildren();
        inicio.hidden = false;
        marcar(-1);
        return;
      }
      peticion?.abort();
      peticion = new AbortController();
      const parametros = new URLSearchParams({ q: termino, section_id: 'busqueda-predictiva' });
      parametros.append('resources[type]', 'query,product,collection');
      parametros.append('resources[limit]', '6');
      parametros.append('resources[limit_scope]', 'each');
      parametros.append('resources[options][fields]', 'title,product_type,variants.title,vendor,variants.sku,variants.barcode,tag');
      try {
        const respuesta = await fetch(`${this.dataset.sugerencias}?${parametros}`, { signal: peticion.signal });
        const html = new DOMParser().parseFromString(await respuesta.text(), 'text/html');
        const contenido = html.querySelector('#BusquedaPredictivaResultados');
        if (!contenido) return;
        // «como Berserk» lleva a «Algo como…»
        const como = termino.match(/^(?:algo\s+)?como\s+(.{2,})/i);
        if (como) {
          const li = Object.assign(document.createElement('li'), { className: 'predictiva__opcion', id: 'PaletaAlgo' });
          li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', 'false');
          const a = Object.assign(document.createElement('a'), { href: `${this.dataset.algo}?algo=${encodeURIComponent(como[1])}#buscadores`, tabIndex: -1 });
          a.append(Object.assign(document.createElement('span'), { textContent: paleta.dataset.textoAlgo?.replace('__x__', como[1]) ?? como[1] }));
          li.append(a);
          const ul = Object.assign(document.createElement('ul'), { className: 'paleta__lista' });
          ul.setAttribute('role', 'group');
          ul.append(li);
          contenido.prepend(ul);
        }
        resultados.replaceChildren(...contenido.childNodes);
        inicio.hidden = true;
        estado.textContent = resultados.querySelector('[data-predictiva-anuncio]')?.textContent ?? '';
        marcar(0);
      } catch (error) {
        if (error.name !== 'AbortError') resultados.replaceChildren();
      }
    };
    const abrir = () => {
      if (paleta.open) return;
      this.querySelector('[data-cajon]')?.close();
      pintarInicio();
      paleta.showModal();
      campo.focus();
      campo.select();
      marcar(-1);
    };
    this.addEventListener('click', (evento) => {
      if (!evento.target.closest('[data-abrir-paleta]')) return;
      evento.preventDefault();
      abrir();
    });
    document.addEventListener('keydown', (evento) => {
      const escribiendo = evento.target.closest?.('input, textarea, select, [contenteditable="true"]');
      if ((evento.key === '/' && !escribiendo) || ((evento.metaKey || evento.ctrlKey) && evento.key.toLowerCase() === 'k')) {
        evento.preventDefault();
        abrir();
      }
    });
    campo.addEventListener('input', () => {
      clearTimeout(temporizador);
      temporizador = setTimeout(buscar, 180);
    });
    campo.addEventListener('keydown', (evento) => {
      if (evento.key === 'ArrowDown' || evento.key === 'ArrowUp') {
        evento.preventDefault();
        marcar(activa + (evento.key === 'ArrowDown' ? 1 : -1));
      } else if (evento.key === 'Enter') {
        const lista = opciones();
        // Un ISBN con un solo libro va directo a la ficha
        const isbn = /^\d{10}(\d{3})?$/.test(campo.value.replace(/[-\s]/g, ''));
        const libros = resultados.querySelectorAll('.predictiva__opcion--libro');
        const elegida = isbn && libros.length === 1 ? libros[0] : lista[activa];
        const enlace = elegida?.querySelector('a') ?? (elegida?.matches('a') ? elegida : null);
        guardarReciente(campo.value);
        if (enlace) {
          evento.preventDefault();
          location.assign(enlace.href);
        }
      }
    });
    paleta.addEventListener('submit', () => guardarReciente(campo.value));
    paleta.addEventListener('click', (evento) => {
      if (evento.target === paleta || evento.target.closest('[data-cerrar-paleta]')) paleta.close();
      if (evento.target.closest('[data-paleta-resultados] a')) guardarReciente(campo.value);
    });
    paleta.addEventListener('pointermove', (evento) => {
      const opcion = evento.target.closest('[role="option"]');
      if (opcion) marcar(opciones().indexOf(opcion));
    });
  }

  activarMisSeries() {
    const panel = this.querySelector('[data-mis-series]');
    const boton = this.querySelector('[data-mis-series-boton]');
    if (!panel || !boton) return;
    const lista = panel.querySelector('[data-mis-series-lista]');
    const vacio = panel.querySelector('[data-mis-series-vacio]');
    const burbuja = boton.querySelector('[data-mis-series-burbuja]');
    const leer = (clave, defecto) => { try { return JSON.parse(localStorage.getItem(clave) || defecto); } catch { return JSON.parse(defecto); } };
    const seguidas = () => leer('comixstore:series', '[]').slice(0, 8);
    const hoy = Date.now();
    const esNuevo = (r) => r.dataset.ultimoEstado === 'preventa'
      || (r.dataset.ultimoFecha && hoy - Date.parse(r.dataset.ultimoFecha) < 45 * 864e5 && hoy >= Date.parse(r.dataset.ultimoFecha));
    const resumen = async (handle) => (await this.traer(`/pages/serie/${handle}`, 'serie-resumen', '#SerieResumen', false))
      ?? this.traer(`/collections/${handle}`, 'serie-resumen', '#SerieResumen', false);
    const ubicar = () => {
      const r = boton.getBoundingClientRect();
      const ancho = Math.min(380, innerWidth - 32);
      panel.style.left = `${Math.max(16, Math.min(innerWidth - ancho - 16, r.right - ancho))}px`;
      panel.style.top = `${r.bottom + 10}px`;
    };
    const actualizarBurbuja = (nuevos) => {
      burbuja.hidden = !nuevos;
      burbuja.textContent = nuevos || '';
      boton.setAttribute('aria-label', nuevos ? boton.dataset.textoNuevos.replace('__n__', nuevos) : boton.dataset.texto);
    };
    const pintar = async () => {
      const handles = seguidas();
      vacio.hidden = handles.length > 0;
      const vistos = leer('comixstore:series-vistos', '{}');
      const filas = await Promise.all(handles.map(async (handle) => {
        const r = await resumen(handle);
        if (!r) return null;
        const tomos = (r.dataset.tomos || '').split(',').filter(Boolean);
        const tengo = new Set(leer(`comixstore:tengo:${handle}`, '[]').map(String));
        const tienes = tomos.filter((id) => tengo.has(id)).length;
        const nuevo = esNuevo(r);
        let linea = panel.dataset.textoTomos.replace('__n__', tomos.length);
        if (tienes) linea = tienes === tomos.length ? panel.dataset.textoCompleta : panel.dataset.textoTienes.replace('__tengo__', tienes).replace('__total__', tomos.length);
        const li = document.createElement('li');
        const a = Object.assign(document.createElement('a'), { className: 'mis-series__serie', href: nuevo ? r.dataset.ultimoUrl : r.dataset.url });
        const img = r.querySelector('img')?.cloneNode(true);
        const texto = document.createElement('span');
        texto.append(Object.assign(document.createElement('strong'), { textContent: r.dataset.nombre }));
        texto.append(Object.assign(document.createElement('span'), { textContent: nuevo ? panel.dataset.textoNuevo.replace('__n__', r.dataset.ultimoNumero || '') : linea }));
        const etiqueta = nuevo ? r.querySelector('.estado')?.cloneNode(true) : null;
        if (etiqueta) texto.append(etiqueta);
        if (img) a.append(img);
        a.append(texto);
        li.append(a);
        return { li, nuevo: nuevo && vistos[handle] !== r.dataset.ultimo, handle, ultimo: r.dataset.ultimo };
      }));
      const validas = filas.filter(Boolean);
      lista.replaceChildren(...validas.map((f) => f.li));
      return validas;
    };
    panel.addEventListener('beforetoggle', (evento) => { if (evento.newState === 'open') ubicar(); });
    panel.addEventListener('toggle', async (evento) => {
      if (evento.newState !== 'open') return;
      ubicar();
      const filas = await pintar();
      const vistos = leer('comixstore:series-vistos', '{}');
      filas.forEach((f) => { vistos[f.handle] = f.ultimo; });
      try { localStorage.setItem('comixstore:series-vistos', JSON.stringify(vistos)); } catch { /* sin almacenamiento */ }
      actualizarBurbuja(0);
    });
    // La burbuja se calcula cuando la página está tranquila, solo si sigues alguna serie
    if (!seguidas().length) return;
    const calcular = async () => actualizarBurbuja((await pintar()).filter((f) => f.nuevo).length);
    if ('requestIdleCallback' in window) requestIdleCallback(calcular, { timeout: 4000 }); else setTimeout(calcular, 2500);
  }

  activarRotativo() {
    const texto = this.querySelector('[data-rotativo]');
    const ejemplos = (texto?.dataset.ejemplos ?? '').split('|').map((e) => e.trim()).filter(Boolean);
    if (!texto || !ejemplos.length) return;
    const frases = [texto.textContent, ...ejemplos.map((e) => this.dataset.textoPrueba.replace('__x__', e))];
    let i = 0;
    setInterval(() => {
      if (document.hidden || movimientoReducido.matches) return;
      i = (i + 1) % frases.length;
      texto.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-6px)' }], { duration: 200, easing: 'ease-in' }).finished.then(() => {
        texto.textContent = frases[i];
        texto.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 300, easing: 'ease-out' });
      });
    }, 3600);
  }
}
customElements.define('cabecera-tienda', CabeceraTienda);

class Libro3D extends HTMLElement {
  connectedCallback() {
    this.giro = -32;
    this.addEventListener('pointerdown', this.empezarArrastre);
    this.addEventListener('keydown', this.girarConTeclado);
  }

  aplicarGiro() {
    this.dataset.tocado = '';
    this.style.setProperty('--giro', `${this.giro}deg`);
  }

  empezarArrastre = (evento) => {
    if (evento.button !== 0) return;
    const inicioX = evento.clientX;
    const giroInicial = this.giro;
    this.setPointerCapture(evento.pointerId);
    this.dataset.arrastrando = '';
    const mover = (e) => {
      this.giro = Math.max(-180, Math.min(180, giroInicial + (e.clientX - inicioX) * 0.6));
      this.aplicarGiro();
    };
    const terminar = () => {
      delete this.dataset.arrastrando;
      this.removeEventListener('pointermove', mover);
      this.removeEventListener('pointerup', terminar);
      this.removeEventListener('pointercancel', terminar);
    };
    this.addEventListener('pointermove', mover);
    this.addEventListener('pointerup', terminar);
    this.addEventListener('pointercancel', terminar);
  };

  girarConTeclado = (evento) => {
    if (evento.key === 'ArrowLeft') this.giro -= 20;
    else if (evento.key === 'ArrowRight') this.giro += 20;
    else return;
    evento.preventDefault();
    this.giro = Math.max(-180, Math.min(180, this.giro));
    this.aplicarGiro();
  };
}
customElements.define('libro-3d', Libro3D);

function activarInclinacion() {
  if (!document.body.hasAttribute('data-inclinacion')) return;
  if (!punteroFino.matches || movimientoReducido.matches) return;
  let cuadro = 0;
  document.addEventListener('pointermove', (evento) => {
    const tarjeta = evento.target.closest?.('[data-inclinable]');
    if (!tarjeta) return;
    cancelAnimationFrame(cuadro);
    cuadro = requestAnimationFrame(() => {
      const caja = tarjeta.getBoundingClientRect();
      const x = (evento.clientX - caja.left) / caja.width - 0.5;
      const y = (evento.clientY - caja.top) / caja.height - 0.5;
      tarjeta.style.setProperty('--inclina-x', `${(y * -7).toFixed(2)}deg`);
      tarjeta.style.setProperty('--inclina-y', `${(x * 9).toFixed(2)}deg`);
    });
  }, { passive: true });
  document.addEventListener('pointerout', (evento) => {
    const tarjeta = evento.target.closest?.('[data-inclinable]');
    if (!tarjeta || tarjeta.contains(evento.relatedTarget)) return;
    tarjeta.style.removeProperty('--inclina-x');
    tarjeta.style.removeProperty('--inclina-y');
  });
}

// La portada de un enlace o formulario: la de su tarjeta, su página del libro, su lomo, su fila o la de la ficha.
function portadaDe(elemento) {
  const pagina = elemento.closest('.pag');
  if (pagina) {
    return pagina.querySelector('.pag__imagen')
      ?? pagina.closest('.libro-hojas__lienzo')?.querySelector(`.pag[data-libro-i="${pagina.dataset.libroI}"] .pag__imagen`) ?? null;
  }
  const contenedor = elemento.closest('.tarjeta, .tira__item, .serie__tomo, .predictiva__opcion, .mis-series__serie');
  if (contenedor) return contenedor.querySelector('.portada__imagen, img');
  return document.body.classList.contains('plantilla-product') ? document.querySelector('.libro__imagen') : null;
}

// La portada que tocas viaja hasta su lugar en la ficha (View Transitions entre páginas), venga de donde venga.
function activarTransicionPortada() {
  if (!document.body.hasAttribute('data-transiciones')) return;
  document.addEventListener('click', (evento) => {
    const enlace = evento.target.closest?.('a[href*="/products/"]');
    const imagen = enlace ? portadaDe(enlace) : null;
    if (!imagen || imagen.classList.contains('libro__imagen')) return;
    // Un solo elemento puede llevar el nombre: la portada de la ficha actual se lo cede
    document.querySelectorAll('.libro__imagen').forEach((otra) => { otra.style.viewTransitionName = 'none'; });
    imagen.style.viewTransitionName = 'portada-libro';
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[style*="view-transition-name"]').forEach((imagen) => imagen.style.removeProperty('view-transition-name'));
  });
}

// El libro vuela en arco desde su portada hasta la bolsa de la cabecera, y la bolsa responde.
function volarALaBolsa(img) {
  const bolsa = document.querySelector('.cabecera__carrito');
  if (!img || !bolsa || movimientoReducido.matches) return Promise.resolve();
  document.querySelector('cabecera-tienda')?.mostrarCabecera?.();
  const a = img.getBoundingClientRect();
  const b = bolsa.getBoundingClientRect();
  if (!a.width || !b.width) return Promise.resolve();
  const capa = document.createElement('div');
  const copia = Object.assign(document.createElement('img'), { src: img.currentSrc || img.src, alt: '', className: 'vuelo-portada' });
  Object.assign(capa.style, { position: 'fixed', left: `${a.left}px`, top: `${a.top}px`, zIndex: 90, pointerEvents: 'none' });
  Object.assign(copia.style, { width: `${a.width}px`, height: `${a.height}px` });
  capa.append(copia);
  document.body.append(capa);
  const dx = b.left + b.width / 2 - (a.left + a.width / 2);
  const dy = b.top + b.height / 2 - (a.top + a.height / 2);
  const duracion = 780;
  capa.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${dx}px)` }], { duration: duracion, easing: 'cubic-bezier(.3,0,.8,.6)', fill: 'forwards' });
  return copia.animate([
    { transform: 'translateY(0) scale(1) rotate(0)', opacity: 1 },
    { transform: `translateY(${Math.min(-60, dy * 0.15 - 90)}px) scale(.62) rotate(-10deg)`, opacity: 1, offset: 0.35 },
    { transform: `translateY(${dy}px) scale(${Math.max(0.08, 24 / a.width)}) rotate(-24deg)`, opacity: 0.7 },
  ], { duration: duracion, easing: 'cubic-bezier(.45,0,.55,1)', fill: 'forwards' }).finished.then(() => {
    capa.remove();
    bolsa.classList.remove('pop');
    void bolsa.offsetWidth;
    bolsa.classList.add('pop');
  });
}


// Devuelve una promesa que se cumple cuando el cambio ya está en la página (con transición, el cambio es diferido).
function cambiarConTransicion(cambio) {
  if (document.startViewTransition && document.body.hasAttribute('data-transiciones') && !movimientoReducido.matches) {
    return document.startViewTransition(cambio).updateCallbackDone;
  }
  cambio();
  return Promise.resolve();
}

// Cuenta animada: el número pasa del valor anterior al nuevo (respeta «reducir movimiento»).
function animarCantidad(elemento, anterior) {
  const numero = (texto) => Number((texto ?? '').replace(/\D/g, '')) || 0;
  const texto = elemento.textContent;
  const hasta = numero(texto);
  const desde = numero(anterior);
  if (movimientoReducido.matches || desde === hasta || !/\d/.test(texto)) return;
  const molde = texto.replace(/[\d.]+/, '__n__');
  const inicio = performance.now();
  const paso = (ahora) => {
    const avance = Math.min(1, (ahora - inicio) / 420);
    const valor = Math.round(desde + (hasta - desde) * (1 - (1 - avance) ** 3));
    elemento.textContent = molde.replace('__n__', valor.toLocaleString('es-CL'));
    if (avance < 1) requestAnimationFrame(paso);
  };
  requestAnimationFrame(paso);
}

async function renderizarResultados(url, { agregarHistorial = true } = {}) {
  const contenedor = document.querySelector('[data-resultados]');
  if (!contenedor) return location.assign(url);
  const destino = new URL(url, location.origin);
  destino.searchParams.set('section_id', contenedor.dataset.resultados);
  contenedor.setAttribute('aria-busy', 'true');
  const respuesta = await fetch(destino);
  const html = new DOMParser().parseFromString(await respuesta.text(), 'text/html');
  const nuevo = html.querySelector('[data-resultados]');
  contenedor.removeAttribute('aria-busy');
  if (!nuevo) return location.assign(url);
  const foco = document.activeElement;
  const claveFoco = foco?.name ? `${foco.name}=${foco.value}` : null;
  // Lo que el cliente tenía abierto en «Afinar» sigue abierto después de actualizar
  const formulario = contenedor.querySelector('[data-filtros]');
  const abierta = formulario?.querySelector('.afinar__faceta[open]')?.dataset.faceta;
  const panel = abierta ? formulario.querySelector(`.afinar__faceta[data-faceta="${abierta}"] .afinar__panel`) : null;
  const desplazado = panel?.scrollTop ?? 0;
  const busquedas = [...(formulario?.querySelectorAll('[data-afinar-buscar]') ?? [])].map((campo) => campo.value);
  const cantidadAntes = contenedor.querySelector('[data-resultados-cantidad]')?.textContent;
  await cambiarConTransicion(() => {
    ['[data-resultados-lista]', '[data-resultados-cantidad]', '[data-filtros]'].forEach((selector) => {
      const actual = contenedor.querySelector(selector);
      const reemplazo = nuevo.querySelector(selector);
      if (actual && reemplazo) actual.replaceWith(reemplazo);
    });
    const hoja = contenedor.querySelector('.afinar-hoja');
    if (hoja?.open) contenedor.querySelectorAll('.afinar__faceta').forEach((faceta) => { faceta.open = true; });
    else if (abierta && innerWidth >= 990) {
      const faceta = contenedor.querySelector(`.afinar__faceta[data-faceta="${abierta}"]`);
      if (faceta) {
        faceta.open = true;
        faceta.querySelector('.afinar__panel').scrollTop = desplazado;
      }
    }
    contenedor.querySelectorAll('[data-afinar-buscar]').forEach((campo, i) => {
      if (!busquedas[i]) return;
      campo.value = busquedas[i];
      campo.dispatchEvent(new Event('input', { bubbles: true }));
    });
    contenedor.querySelector('[data-afinar-flotante]')?.toggleAttribute('data-visible', contenedor.dataset.flotante === 'si');
  });
  activarPrecio(contenedor);
  if (claveFoco) {
    const [nombre, valor] = claveFoco.split('=');
    [...contenedor.querySelectorAll(`[name="${CSS.escape(nombre)}"]`)].find((campo) => campo.value === valor)?.focus({ preventScroll: true });
  }
  const cantidad = contenedor.querySelector('[data-resultados-cantidad]');
  if (cantidad) {
    animarCantidad(cantidad, cantidadAntes);
    document.querySelectorAll('[data-afinar-cuenta]').forEach((cuenta) => { cuenta.textContent = cantidad.textContent.trim(); });
  }
  const total = contenedor.querySelector('[data-afinar-total]');
  if (total) animarCantidad(total, cantidadAntes);
  const anuncio = contenedor.querySelector('[data-resultados-anuncio]');
  if (anuncio && cantidad) anuncio.textContent = cantidad.textContent;
  if (agregarHistorial) {
    history.pushState({ resultados: true, afinar: (history.state?.afinar ?? 0) + 1 }, '', url);
  }
  contenedor.querySelectorAll('[data-afinar-deshacer]').forEach((boton) => { boton.hidden = !(history.state?.afinar > 0); });
}

// El deslizador doble del precio escribe en los campos «Desde» y «Hasta», que son los que se envían.
function activarPrecio(raiz) {
  raiz.querySelectorAll('[data-precio]').forEach((caja) => {
    const maximo = Number(caja.dataset.maximo);
    const desde = caja.querySelector('[data-rango="desde"]');
    const hasta = caja.querySelector('[data-rango="hasta"]');
    const montoDesde = caja.querySelector('[data-monto="desde"]');
    const montoHasta = caja.querySelector('[data-monto="hasta"]');
    const tramo = caja.querySelector('[data-tramo]');
    if (!desde || !hasta) return;
    const pintar = () => {
      tramo.style.insetInlineStart = `${(Number(desde.value) / maximo) * 100}%`;
      tramo.style.insetInlineEnd = `${100 - (Number(hasta.value) / maximo) * 100}%`;
      desde.setAttribute('aria-valuetext', `$${Number(desde.value).toLocaleString('es-CL')}`);
      hasta.setAttribute('aria-valuetext', `$${Number(hasta.value).toLocaleString('es-CL')}`);
    };
    const mover = (evento) => {
      let a = Number(desde.value);
      let b = Number(hasta.value);
      if (a > b - 500) {
        if (evento.target === desde) a = b - 500; else b = a + 500;
        desde.value = a;
        hasta.value = b;
      }
      montoDesde.value = a > 0 ? a : '';
      montoHasta.value = b < maximo ? b : '';
      pintar();
    };
    desde.addEventListener('input', mover);
    hasta.addEventListener('input', mover);
    pintar();
  });
}

function activarResultados() {
  const contenedor = document.querySelector('[data-resultados]');
  if (!contenedor) return;

  if (contenedor.dataset.redirigir) {
    location.replace(contenedor.dataset.redirigir);
    return;
  }

  activarPrecio(contenedor);
  let temporizador = 0;
  contenedor.addEventListener('change', (evento) => {
    const formulario = evento.target.closest('[data-filtros]');
    if (!formulario || evento.target.matches('[data-afinar-buscar], [data-rango]')) return;
    clearTimeout(temporizador);
    temporizador = setTimeout(() => {
      const parametros = new URLSearchParams(new FormData(formulario));
      for (const [clave, valor] of [...parametros]) if (valor === '') parametros.delete(clave);
      if (parametros.get('sort_by') === formulario.dataset.ordenDefecto) parametros.delete('sort_by');
      renderizarResultados(`${formulario.action}?${parametros}`);
    }, 250);
  });
  // Al soltar el deslizador, se actualiza con el precio elegido
  contenedor.addEventListener('change', (evento) => {
    if (!evento.target.matches('[data-rango]')) return;
    evento.target.closest('[data-precio]')?.querySelector('[data-monto="desde"]')?.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Buscar dentro de un filtro con muchas opciones
  contenedor.addEventListener('input', (evento) => {
    const campo = evento.target.closest('[data-afinar-buscar]');
    if (!campo) return;
    const texto = campo.value.trim().toLocaleLowerCase('es');
    campo.closest('.afinar__panel').querySelectorAll('.afinar__opcion').forEach((opcion) => {
      opcion.hidden = Boolean(texto) && !opcion.dataset.texto.includes(texto);
    });
  });
  contenedor.addEventListener('keydown', (evento) => {
    if (evento.key === 'Enter' && evento.target.matches('[data-afinar-buscar]')) evento.preventDefault();
    if (evento.key === 'Escape') {
      const abierta = contenedor.querySelector('.afinar__faceta[open]');
      if (abierta && innerWidth >= 990) {
        abierta.open = false;
        abierta.querySelector('summary').focus();
      }
    }
  });

  // En computador, un filtro abierto a la vez; se cierra al hacer clic fuera
  contenedor.addEventListener('toggle', (evento) => {
    const faceta = evento.target;
    if (!faceta.matches?.('.afinar__faceta') || !faceta.open || innerWidth < 990) return;
    contenedor.querySelectorAll('.afinar__faceta[open]').forEach((otra) => { if (otra !== faceta) otra.open = false; });
  }, true);
  document.addEventListener('pointerdown', (evento) => {
    if (innerWidth < 990 || evento.target.closest('.afinar__barra')) return;
    contenedor.querySelectorAll('.afinar__faceta[open]').forEach((faceta) => { faceta.open = false; });
  });

  contenedor.addEventListener('submit', (evento) => {
    const formulario = evento.target.closest('[data-filtros]');
    if (!formulario) return;
    evento.preventDefault();
    formulario.closest('dialog')?.close();
  });

  contenedor.addEventListener('click', async (evento) => {
    const abrir = evento.target.closest('[data-abrir-filtros]');
    if (abrir) {
      const hoja = document.getElementById(abrir.dataset.abrirFiltros);
      hoja?.querySelectorAll('.afinar__faceta').forEach((faceta) => { faceta.open = true; });
      hoja?.showModal();
    }

    if (evento.target.closest('[data-cerrar-filtros]')) evento.target.closest('dialog')?.close();
    const hoja = evento.target.matches?.('.afinar-hoja') ? evento.target : null;
    if (hoja) hoja.close();

    if (evento.target.closest('[data-afinar-deshacer]')) {
      history.back();
      return;
    }

    const enlace = evento.target.closest('a.chip, [data-afinar-enlace]');
    if (enlace) {
      evento.preventDefault();
      renderizarResultados(enlace.href);
    }

    const mas = evento.target.closest('[data-cargar-mas]');
    if (mas) {
      evento.preventDefault();
      mas.setAttribute('aria-disabled', 'true');
      const destino = new URL(mas.href, location.origin);
      destino.searchParams.set('section_id', contenedor.dataset.resultados);
      const html = new DOMParser().parseFromString(await (await fetch(destino)).text(), 'text/html');
      const grilla = contenedor.querySelector('[data-grilla]');
      const nuevos = [...html.querySelectorAll('[data-grilla] > li')];
      grilla.append(...nuevos);
      contenedor.querySelector('[data-grilla-mas]').replaceWith(html.querySelector('[data-grilla-mas]'));
      nuevos[0]?.querySelector('.tarjeta__enlace')?.focus({ preventScroll: true });
      const anuncio = contenedor.querySelector('[data-resultados-anuncio]');
      if (anuncio) anuncio.textContent = contenedor.querySelector('[data-grilla-mas] .dato')?.textContent ?? '';
      history.replaceState(history.state, '', mas.href);
    }
  });

  // En el celular, el botón flotante aparece cuando el botón de arriba quedó atrás
  const arriba = contenedor.querySelector('.resultados__abrir-filtros');
  const flotante = contenedor.querySelector('[data-afinar-flotante]');
  if (arriba && flotante && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entrada]) => {
      const visible = !entrada.isIntersecting && entrada.boundingClientRect.top < 0;
      contenedor.dataset.flotante = visible ? 'si' : '';
      contenedor.querySelector('[data-afinar-flotante]')?.toggleAttribute('data-visible', visible);
    }).observe(arriba);
  }

  window.addEventListener('popstate', () => renderizarResultados(location.href, { agregarHistorial: false }));
}

const carrito = {
  dialogo: () => document.getElementById('CarritoLateral'),

  seccionesPedidas() {
    const ids = ['carrito-lateral'];
    const pagina = document.querySelector('.pagina-carrito')?.closest('.shopify-section');
    if (pagina) ids.push(pagina.id.replace('shopify-section-', ''));
    return ids;
  },

  aplicarSecciones(secciones = {}) {
    for (const [id, html] of Object.entries(secciones)) {
      if (!html) continue;
      const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-carrito-contenido]');
      const destino = id === 'carrito-lateral'
        ? this.dialogo()?.querySelector('[data-carrito-contenido]')
        : document.getElementById(`shopify-section-${id}`)?.querySelector('[data-carrito-contenido]');
      if (nuevo && destino) destino.replaceWith(nuevo);
    }
  },

  async actualizarBurbuja() {
    const { item_count: cantidad } = await (await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`)).json();
    const enlace = document.querySelector('[data-abrir-carrito]');
    if (!enlace) return;
    let burbuja = enlace.querySelector('.cabecera__burbuja');
    if (cantidad > 0 && !burbuja) {
      burbuja = Object.assign(document.createElement('span'), { className: 'cabecera__burbuja' });
      burbuja.setAttribute('aria-hidden', 'true');
      enlace.append(burbuja);
    }
    if (burbuja) burbuja.textContent = cantidad;
    if (!movimientoReducido.matches) {
      enlace.classList.remove('pop');
      void enlace.offsetWidth;
      enlace.classList.add('pop');
    }
    if (navigator.vibrate && !movimientoReducido.matches) navigator.vibrate(12);
  },

  anunciar(texto) {
    const anuncio = this.dialogo()?.querySelector('[data-carrito-anuncio]');
    if (anuncio) anuncio.textContent = texto;
  },

  abrir() {
    const dialogo = this.dialogo();
    if (dialogo && !dialogo.open) dialogo.showModal();
  },

  // Aviso breve abajo: la portada, lo agregado y «Ver bolsa». Se queda mientras tenga el mouse o el foco.
  avisar(texto, portada) {
    let aviso = document.querySelector('.aviso-bolsa');
    if (!aviso) {
      aviso = Object.assign(document.createElement('div'), { className: 'aviso-bolsa' });
      aviso.addEventListener('pointerenter', () => clearTimeout(this.esperaAviso));
      aviso.addEventListener('focusin', () => clearTimeout(this.esperaAviso));
      aviso.addEventListener('pointerleave', () => this.cerrarAviso(aviso));
      document.body.append(aviso);
    }
    const ver = Object.assign(document.createElement('button'), { type: 'button', className: 'aviso-bolsa__ver', textContent: this.dialogo()?.dataset.textoVerBolsa ?? '' });
    ver.addEventListener('click', () => { delete aviso.dataset.visible; this.abrir(); });
    const imagen = portada ? Object.assign(document.createElement('img'), { src: portada.currentSrc || portada.src, alt: '', className: 'aviso-bolsa__portada' }) : null;
    aviso.replaceChildren(...[imagen, Object.assign(document.createElement('p'), { textContent: texto }), ver].filter(Boolean));
    aviso.dataset.visible = '';
    this.cerrarAviso(aviso);
  },

  cerrarAviso(aviso) {
    clearTimeout(this.esperaAviso);
    this.esperaAviso = setTimeout(() => { if (!aviso.contains(document.activeElement)) delete aviso.dataset.visible; }, 4500);
  },

  async pedir(url, cuerpo) {
    const respuesta = await fetch(url, {
      method: 'POST',
      headers: cuerpo instanceof FormData ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: cuerpo instanceof FormData ? cuerpo : JSON.stringify(cuerpo),
    });
    const datos = await respuesta.json();
    if (!respuesta.ok) throw new Error(datos.description || datos.message || 'error');
    return datos;
  },

  async agregar(formulario) {
    const boton = formulario.querySelector('[type="submit"]');
    boton?.setAttribute('aria-busy', 'true');
    const datos = new FormData(formulario);
    datos.append('sections', this.seccionesPedidas().join(','));
    datos.append('sections_url', location.pathname);
    const portada = portadaDe(formulario);
    const vuelo = volarALaBolsa(portada);
    try {
      const respuesta = await this.pedir(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, datos);
      this.aplicarSecciones(respuesta.sections);
      await vuelo;
      await this.actualizarBurbuja();
      const plantilla = this.dialogo()?.dataset.textoAgregado ?? '';
      const texto = plantilla.replace('__titulo__', respuesta.product_title ?? '');
      // Según el ajuste del tema: se abre el carrito o se confirma con un aviso, sin salir de la página
      if (document.body.dataset.alAgregar === 'abrir') this.abrir(); else this.avisar(texto, portada);
      this.anunciar(texto);
    } catch (error) {
      this.abrir();
      this.anunciar(error.message);
      window.alert(error.message);
    } finally {
      boton?.removeAttribute('aria-busy');
    }
  },

  async cambiarLinea(linea, cantidad) {
    const respuesta = await this.pedir(`${window.Shopify?.routes?.root ?? '/'}cart/change.js`, {
      line: Number(linea), quantity: Math.max(0, Number(cantidad)), sections: this.seccionesPedidas(), sections_url: location.pathname,
    });
    this.aplicarSecciones(respuesta.sections);
    await this.actualizarBurbuja();
  },

  async codigosActuales() {
    const datos = await (await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`)).json();
    return (datos.discount_codes ?? []).map((d) => d.code);
  },

  // Shopify reemplaza los códigos con cada envío: se mandan los que ya están más el nuevo.
  async aplicarDescuento(codigo, contenedor) {
    const igual = (a) => a.toUpperCase() === codigo.toUpperCase();
    const campo = contenedor.querySelector('input[name="discount"]')?.id;
    const codigos = (await this.codigosActuales()).filter((c) => !igual(c)).concat(codigo);
    const respuesta = await this.pedir(`${window.Shopify?.routes?.root ?? '/'}cart/update.js`, {
      discount: codigos.join(','), sections: this.seccionesPedidas(), sections_url: location.pathname,
    });
    const aplicado = (respuesta.discount_codes ?? []).some((d) => igual(d.code) && d.applicable);
    // cart/update.js entrega asignaciones ({ amount, discount_application }); cart.js, aplicaciones directas.
    const conMonto = [
      ...(respuesta.cart_level_discount_applications ?? []),
      ...(respuesta.items ?? []).flatMap((l) => l.line_level_discount_allocations ?? []),
    ].map((d) => d.discount_application ?? d).some((d) => d?.title && igual(d.title));
    this.aplicarSecciones(respuesta.sections);
    const zona = document.getElementById(campo)?.closest('[data-descuento]') ?? contenedor;
    if (!aplicado) {
      const error = zona.querySelector('[data-descuento-error]');
      if (error) error.hidden = false;
    } else if (!conMonto) {
      // Los códigos de envío no rebajan el carrito: Shopify los aplica al calcular el envío.
      const aviso = zona.querySelector('[data-descuento-envio]');
      if (aviso) {
        aviso.textContent = aviso.dataset.texto.replace('__codigo__', codigo.toUpperCase());
        aviso.hidden = false;
      }
    }
  },

  async quitarDescuento(codigo) {
    const restantes = (await this.codigosActuales()).filter((c) => c.toUpperCase() !== codigo.toUpperCase());
    const respuesta = await this.pedir(`${window.Shopify?.routes?.root ?? '/'}cart/update.js`, {
      discount: restantes.join(','), sections: this.seccionesPedidas(), sections_url: location.pathname,
    });
    this.aplicarSecciones(respuesta.sections);
  },
};

function activarCarrito() {
  document.addEventListener('submit', (evento) => {
    const formulario = evento.target;
    if (!(formulario instanceof HTMLFormElement)) return;
    if (!formulario.action.includes('/cart/add')) return;
    evento.preventDefault();
    carrito.agregar(formulario);
  });

  document.addEventListener('click', (evento) => {
    const abrir = evento.target.closest('[data-abrir-carrito]');
    if (abrir && carrito.dialogo()) {
      evento.preventDefault();
      carrito.abrir();
      return;
    }
    if (evento.target.closest('[data-cerrar-carrito]')) carrito.dialogo()?.close();
    if (evento.target === carrito.dialogo()) carrito.dialogo().close();

    const cambio = evento.target.closest('[data-cambiar-linea]');
    if (cambio) {
      evento.preventDefault();
      carrito.cambiarLinea(cambio.dataset.cambiarLinea, cambio.dataset.cantidadNueva).catch((e) => window.alert(e.message));
    }

    const descuento = evento.target.closest('[data-aplicar-descuento]');
    if (descuento) {
      const contenedor = descuento.closest('[data-descuento]');
      const codigo = contenedor?.querySelector('input[name="discount"]')?.value.trim();
      if (codigo) carrito.aplicarDescuento(codigo, contenedor).catch((e) => window.alert(e.message));
    }

    const quitarCodigo = evento.target.closest('[data-quitar-descuento]');
    if (quitarCodigo) carrito.quitarDescuento(quitarCodigo.dataset.quitarDescuento).catch((e) => window.alert(e.message));

    const paso = evento.target.closest('[data-cantidad]');
    if (paso) {
      const campo = paso.parentElement.querySelector('input[type="number"]');
      campo.value = Math.max(1, Number(campo.value) + Number(paso.dataset.cantidad));
    }

    const alternar = evento.target.closest('[data-alternar-3d]');
    if (alternar) {
      const medios = alternar.closest('.libro__medios');
      const en3d = alternar.getAttribute('aria-pressed') !== 'true';
      medios.querySelector('[data-vista="portada"]').hidden = en3d;
      medios.querySelector('[data-vista="3d"]').hidden = !en3d;
      alternar.setAttribute('aria-pressed', String(en3d));
      alternar.textContent = en3d ? alternar.dataset.textoPortada : alternar.dataset.texto3d;
    }
  });

  document.addEventListener('change', (evento) => {
    const campo = evento.target.closest('[data-linea-cantidad]');
    if (campo) carrito.cambiarLinea(campo.dataset.lineaCantidad, campo.value).catch((e) => window.alert(e.message));
  });
}

function activarRecomendaciones() {
  const seccion = document.querySelector('[data-recomendaciones]');
  if (!seccion) return;
  const observador = new IntersectionObserver(async (entradas) => {
    if (!entradas.some((e) => e.isIntersecting)) return;
    observador.disconnect();
    const html = await (await fetch(seccion.dataset.recomendaciones)).text();
    const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recomendaciones]');
    if (!nuevo) return;
    // Fuera los tomos de la misma serie (ya están en su estante); a cada uno, el motivo: los subgéneros en común.
    const actuales = new Set((seccion.dataset.subgeneros || '').split(',').filter(Boolean));
    const libros = [...nuevo.querySelectorAll('li[data-subgeneros]')];
    libros.forEach((libro) => {
      if (seccion.dataset.serie && libro.dataset.serie === seccion.dataset.serie) return libro.remove();
      const comunes = libro.dataset.subgeneros.split(',').filter((s) => actuales.has(s)).slice(0, 2);
      if (comunes.length) libro.append(Object.assign(document.createElement('p'), { className: 'recomendaciones__motivo', textContent: comunes.join(' · ') }));
    });
    nuevo.querySelectorAll('li[data-subgeneros]').forEach((libro, i) => { if (i >= Number(seccion.dataset.cantidad || 8)) libro.remove(); });
    if (nuevo.querySelector('li')) seccion.innerHTML = nuevo.innerHTML;
  }, { rootMargin: '600px 0px' });
  observador.observe(seccion);
}

// Libro de novedades: muestra al tiro un visor (una novedad a la vez) y, cuando la sección está por aparecer, descarga
// page-flip para pasar las hojas de verdad. Con «reducir movimiento» se queda en el visor, sin giro.
class LibroNovedades extends HTMLElement {
  connectedCallback() {
    this.libro = this.querySelector('[data-libro]');
    this.escena = this.querySelector('[data-libro-escena]');
    this.marcas = this.querySelector('[data-libro-marcas]');
    this.cuenta = this.querySelector('[data-libro-cuenta]');
    this.anuncio = this.querySelector('[data-libro-anuncio]');
    this.anterior = this.querySelector('[data-libro-anterior]');
    this.siguiente = this.querySelector('[data-libro-siguiente]');
    this.ayuda = this.querySelector('[data-libro-ayuda]');
    this.mano = this.querySelector('[data-libro-mano]');
    if (!this.libro) return;
    this.mes = this.querySelector('.libro-hojas__mes:not([hidden])')?.dataset.mes ?? '1';
    this.i = -1;
    this.armar();
    this.anterior.addEventListener('click', () => { this.tocar(); this.mover(-1); });
    this.siguiente.addEventListener('click', () => { this.tocar(); this.mover(1); });
    this.marcas.addEventListener('click', (evento) => {
      const marca = evento.target.closest('[data-ir]');
      if (!marca) return;
      this.tocar();
      this.irA(Number(marca.dataset.ir));
    });
    this.escena.addEventListener('keydown', (evento) => {
      if (evento.target.closest('input, select, textarea')) return;
      if (evento.key !== 'ArrowRight' && evento.key !== 'ArrowLeft') return;
      evento.preventDefault();
      this.tocar();
      this.mover(evento.key === 'ArrowRight' ? 1 : -1);
    });
    this.libro.addEventListener('click', (evento) => { if (evento.target.closest('[data-libro-tapa]')) this.irA(-1); });
    this.libro.addEventListener('pointerdown', (evento) => { if (evento.isTrusted) this.tocar(); });
    this.querySelectorAll('[data-mes-boton]').forEach((boton) => boton.addEventListener('click', () => this.cambiarMes(boton)));
    if (!movimientoReducido.matches && 'IntersectionObserver' in window) {
      new IntersectionObserver((entradas, observador) => {
        if (!entradas.some((e) => e.isIntersecting)) return;
        observador.disconnect();
        this.cargarLibreria();
      }, { rootMargin: '600px 0px' }).observe(this);
    }
    let ancho = innerWidth;
    addEventListener('resize', () => {
      clearTimeout(this.esperaResize);
      this.esperaResize = setTimeout(() => {
        if (Math.abs(innerWidth - ancho) < 4) return;
        ancho = innerWidth;
        if (this.modo() !== this.modoActual) this.armar(Math.min(this.i, this.cantidad() - 1));
      }, 250);
    });
  }

  modo() { return this.escena.clientWidth >= 760 ? 'doble' : 'simple'; }
  fuente() { return this.libro.querySelector(`.libro-hojas__mes[data-mes="${this.mes}"]`); }
  cantidad() { return this.fuente().querySelectorAll('.pag--izq').length; }

  // Copias de las páginas del mes, en el orden del modo: en el celular, portada e información en una sola página.
  paginas(modo) {
    const fuente = this.fuente();
    const tapa = fuente.querySelector('.pag--tapa').cloneNode(true);
    const contra = fuente.querySelector('.pag--contra').cloneNode(true);
    const izq = [...fuente.querySelectorAll('.pag--izq')];
    const der = [...fuente.querySelectorAll('.pag--der')];
    const medio = izq.flatMap((pagina, k) => {
      if (modo === 'doble') return [pagina.cloneNode(true), der[k].cloneNode(true)];
      const unica = Object.assign(document.createElement('div'), { className: 'pag pag--unica' });
      unica.dataset.libroI = pagina.dataset.libroI;
      const marco = Object.assign(document.createElement('div'), { className: 'pag__marco' });
      marco.append(...pagina.querySelector('.pag__marco').cloneNode(true).children, der[k].querySelector('.pag__info').cloneNode(true));
      unica.append(marco);
      return [unica];
    });
    return [tapa, ...medio, contra];
  }

  armar(irA = -1) {
    this.modoActual = this.modo();
    this.pf?.destroy?.();
    this.pf = null;
    this.lienzo?.remove();
    this.lienzo = Object.assign(document.createElement('div'), { className: 'libro-hojas__lienzo' });
    this.lienzo.append(...this.paginas(this.modoActual));
    this.libro.append(this.lienzo);
    this.libro.dataset.iniciado = '';
    delete this.libro.dataset.volteable;
    this.marcas.replaceChildren(...[...this.fuente().querySelectorAll('.pag--der')].map((pagina, k) => {
      const boton = Object.assign(document.createElement('button'), { type: 'button', className: 'libro-marca' });
      boton.dataset.ir = k;
      boton.setAttribute('aria-label', `${k + 1}. ${pagina.querySelector('.pag__titulo')?.textContent.trim() ?? ''}`);
      return boton;
    }));
    if (window.St && !movimientoReducido.matches) this.armarVolteable(irA);
    else this.mostrarQuieto(irA, false);
  }

  // Visor sin giro: la tapa, una novedad (portada e información) o la contratapa.
  mostrarQuieto(i, anunciar = true) {
    const n = this.cantidad();
    this.i = Math.max(-1, Math.min(n, i));
    this.lienzo.classList.add('libro-hojas__lienzo--quieto');
    this.lienzo.classList.toggle('libro-hojas__lienzo--simple', this.modoActual === 'simple');
    this.lienzo.querySelectorAll('.pag').forEach((pagina) => {
      const visible = this.i < 0 ? pagina.classList.contains('pag--tapa')
        : this.i >= n ? pagina.classList.contains('pag--contra')
        : pagina.dataset.libroI === String(this.i + 1);
      pagina.toggleAttribute('data-visible', visible);
      pagina.classList.toggle('pag--activa', visible);
    });
    this.actualizar(anunciar);
  }

  armarVolteable(irA) {
    const doble = this.modoActual === 'doble';
    const alto = doble ? 640 : 620;
    const ancho = doble ? 460 : 380;
    this.lienzo.classList.remove('libro-hojas__lienzo--quieto');
    this.libro.dataset.volteable = '';
    this.pf = new window.St.PageFlip(this.lienzo, {
      width: ancho, height: alto, size: 'stretch', minWidth: 240, maxWidth: doble ? 500 : 460, minHeight: 360, maxHeight: doble ? 700 : 800,
      showCover: true, usePortrait: !doble, mobileScrollSupport: true, maxShadowOpacity: 0.45, flippingTime: 900,
      startPage: irA < 0 ? 0 : doble ? 1 + 2 * irA : 1 + irA,
    });
    this.pf.loadFromHTML([...this.lienzo.querySelectorAll(':scope > .pag')]);
    this.pf.on('flip', (evento) => this.alCambiar(evento.data));
    this.pf.on('changeState', (evento) => {
      if (evento.data === 'user_fold' || evento.data === 'flipping') {
        const calculo = this.pf.getFlipController().getCalculation();
        if (calculo) this.preparar(this.i + (calculo.getDirection() === 0 ? 1 : -1));
      } else if (evento.data === 'read' && this.preparado != null) {
        setTimeout(() => {
          if (this.preparado == null || this.preparado === this.libroDePagina(this.pf.getCurrentPageIndex())) return;
          this.lienzo.querySelectorAll(`[data-libro-i="${this.preparado + 1}"]`).forEach((p) => p.classList.remove('pag--activa'));
          this.preparado = null;
          this.centrar(this.i);
        }, 0);
      }
    });
    this.alCambiar(this.pf.getCurrentPageIndex(), false);
    this.vigilarPista();
  }

  libroDePagina(p) {
    const n = this.cantidad();
    if (p <= 0) return -1;
    const i = this.modoActual === 'doble' ? Math.floor((p - 1) / 2) : p - 1;
    return Math.min(i, n);
  }

  // Al empezar a girar se anima la página que viene, no después: así no hay parpadeo al terminar el giro.
  preparar(i) {
    const n = this.cantidad();
    const destino = Math.max(-1, Math.min(n, i));
    if (destino === this.preparado || destino === this.i) return;
    this.preparado = destino;
    this.centrar(destino);
    this.lienzo.querySelectorAll(`[data-libro-i="${destino + 1}"]`).forEach((p) => {
      p.classList.remove('pag--activa');
      void p.offsetWidth;
      p.classList.add('pag--activa');
    });
  }

  alCambiar(p, anunciar = true) {
    this.i = this.libroDePagina(p);
    this.lienzo.querySelectorAll('.pag--activa').forEach((pagina) => { if (pagina.dataset.libroI !== String(this.i + 1)) pagina.classList.remove('pag--activa'); });
    this.lienzo.querySelectorAll(`[data-libro-i="${this.i + 1}"]`).forEach((pagina) => pagina.classList.add('pag--activa'));
    this.preparado = null;
    this.centrar(this.i);
    this.actualizar(anunciar);
  }

  // Mientras el libro está cerrado (tapa o contratapa), queda centrado.
  centrar(i) {
    const n = this.cantidad();
    this.libro.dataset.tapa = this.modoActual !== 'doble' || !this.pf ? '' : i < 0 ? 'cerrada' : i >= n ? 'final' : '';
  }

  actualizar(anunciar) {
    const n = this.cantidad();
    this.marcas.querySelectorAll('.libro-marca').forEach((marca, k) => marca.setAttribute('aria-current', String(k === this.i)));
    this.cuenta.textContent = this.i < 0 ? this.dataset.textoTapa : this.i >= n ? this.dataset.textoFin : `${this.i + 1} / ${n}`;
    this.anterior.disabled = this.i < 0;
    this.siguiente.disabled = this.i >= n;
    // Las portadas de las páginas que vienen se descargan antes de que la hoja gire
    for (let k = this.i + 1; k <= this.i + 3; k++) this.lienzo.querySelectorAll(`[data-libro-i="${k + 1}"] img`).forEach((img) => { img.loading = 'eager'; });
    if (!anunciar) return;
    const pagina = this.fuente().querySelector(`.pag--der[data-libro-i="${this.i + 1}"]`);
    this.anuncio.textContent = this.i < 0 ? this.dataset.textoTapa : this.i >= n ? this.dataset.textoFin
      : this.dataset.textoAnuncio.replace('__n__', this.i + 1).replace('__total__', n)
        .replace('__titulo__', pagina?.querySelector('.pag__titulo')?.textContent.trim() ?? '')
        .replace('__precio__', pagina?.querySelector('.precio')?.textContent.replace(/\s+/g, ' ').trim() ?? '');
  }

  mover(paso) {
    if (this.pf) {
      const siguiente = this.i + paso;
      if (siguiente >= -1 && siguiente <= this.cantidad()) this.centrar(siguiente);
      paso > 0 ? this.pf.flipNext() : this.pf.flipPrev();
    } else this.mostrarQuieto(this.i + paso);
  }

  irA(i) {
    if (this.pf) {
      this.centrar(i);
      this.pf.flip(i < 0 ? 0 : this.modoActual === 'doble' ? 1 + 2 * i : 1 + i);
    } else this.mostrarQuieto(i);
  }

  cambiarMes(boton) {
    if (boton.dataset.mesBoton === this.mes) return;
    this.querySelectorAll('[data-mes-boton]').forEach((b) => b.setAttribute('aria-pressed', String(b === boton)));
    this.mes = boton.dataset.mesBoton;
    this.libro.dataset.cambiando = '';
    setTimeout(() => {
      this.armar(-1);
      requestAnimationFrame(() => delete this.libro.dataset.cambiando);
    }, movimientoReducido.matches ? 0 : 320);
  }

  cargarLibreria() {
    if (window.St) { this.armar(this.i); return; }
    const script = Object.assign(document.createElement('script'), { src: this.dataset.libreria, async: true });
    script.addEventListener('load', () => this.armar(this.i));
    document.head.append(script);
  }

  tocar() {
    if (this.tocado) return;
    this.tocado = true;
    if (this.ayuda) {
      this.ayuda.dataset.hecho = '';
      delete this.ayuda.dataset.activa;
    }
  }

  // La tapa levanta la esquina sola, para mostrar que las hojas se pasan; dos veces como máximo y nunca si ya tocaste.
  vigilarPista() {
    if (this.vigilando || !this.hasAttribute('data-pista')) return;
    this.vigilando = true;
    let veces = 0;
    let espera = 0;
    new IntersectionObserver((entradas) => {
      clearTimeout(espera);
      if (!entradas[0].isIntersecting || this.tocado || veces >= 2) return;
      espera = setTimeout(async () => { veces++; await this.pista(); }, veces ? 6000 : 700);
    }, { threshold: 0.6 }).observe(this.libro);
  }

  async pista() {
    const pf = this.pf;
    if (!pf || this.tocado || this.enPista || movimientoReducido.matches || this.i !== -1) return;
    this.enPista = true;
    this.ayuda?.setAttribute('data-activa', '');
    const bloque = this.lienzo.querySelector('.stf__block');
    const r = pf.getBoundsRect();
    const inicio = { x: r.left + r.width - 3, y: r.top + r.height - 3 };
    const fin = { x: r.left + r.width - Math.min(r.pageWidth * 0.55, 240), y: r.top + r.height * 0.84 };
    const suave = (t) => (t < 0.5 ? 4 * t * t * t : 1 - ((-2 * t + 2) ** 3) / 2);
    const poner = (p) => {
      const caja = bloque.getBoundingClientRect();
      this.mano.style.transform = `translate(${Math.min(innerWidth - 40, caja.left + p.x)}px, ${caja.top + p.y}px)`;
    };
    const recorrer = (a, b, ms) => new Promise((listo) => {
      const t0 = performance.now();
      const paso = (t) => {
        if (this.tocado) { listo(); return; }
        const k = Math.min(1, (t - t0) / ms);
        const e = suave(k);
        const p = { x: a.x + (b.x - a.x) * e, y: a.y + (b.y - a.y) * e - Math.sin(e * Math.PI) * 30 };
        pf.userMove(p, false);
        poner(p);
        if (k < 1) requestAnimationFrame(paso); else listo();
      };
      requestAnimationFrame(paso);
    });
    const pausa = (ms) => new Promise((listo) => setTimeout(listo, ms));
    poner(inicio);
    this.mano.dataset.visible = '';
    await pausa(450);
    pf.startUserTouch(inicio);
    await recorrer(inicio, fin, 1000);
    await pausa(280);
    await recorrer(fin, inicio, 700);
    pf.userStop(inicio);
    delete this.mano.dataset.visible;
    setTimeout(() => { this.mano.style.transform = ''; }, 300);
    await pausa(900);
    if (!this.tocado) this.ayuda?.removeAttribute('data-activa');
    this.enPista = false;
  }
}
customElements.define('libro-novedades', LibroNovedades);

class CalendarioFiltros extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (evento) => {
      const boton = evento.target.closest('[data-filtro-tipo]');
      if (!boton) return;
      const tipo = boton.dataset.filtroTipo;
      this.querySelectorAll('[data-filtro-tipo]').forEach((b) => b.setAttribute('aria-pressed', String(b === boton)));
      cambiarConTransicion(() => {
        this.querySelectorAll('li[data-tipo]').forEach((item) => {
          item.hidden = Boolean(tipo) && item.dataset.tipo !== tipo;
        });
      });
      const anuncio = this.querySelector('[data-calendario-anuncio]');
      if (anuncio) anuncio.textContent = boton.textContent.trim().replace(/\s+/g, ' ');
    });
  }
}
customElements.define('calendario-filtros', CalendarioFiltros);

function activarSeguirSerie() {
  const clave = 'comixstore:series';
  const leer = () => { try { return JSON.parse(localStorage.getItem(clave) || '[]'); } catch { return []; } };
  const guardar = (lista) => { try { localStorage.setItem(clave, JSON.stringify(lista)); } catch { /* sin almacenamiento */ } };
  const pintar = (boton, siguiendo) => {
    boton.setAttribute('aria-pressed', String(siguiendo));
    boton.textContent = siguiendo ? boton.dataset.textoSiguiendo : boton.dataset.textoSeguir;
  };
  document.querySelectorAll('[data-seguir-serie]').forEach((boton) => pintar(boton, leer().includes(boton.dataset.seguirSerie)));
  document.addEventListener('click', (evento) => {
    const boton = evento.target.closest('[data-seguir-serie]');
    if (!boton) return;
    const lista = leer();
    const serie = boton.dataset.seguirSerie;
    const siguiendo = !lista.includes(serie);
    guardar(siguiendo ? [...lista, serie] : lista.filter((s) => s !== serie));
    pintar(boton, siguiendo);
  });
}

function activarAvisoAdultos() {
  document.addEventListener('click', (evento) => {
    if (!evento.target.closest('[data-confirmar-adultos]')) return;
    try { localStorage.setItem('comixstore:adultos', 'si'); } catch { /* sin almacenamiento: vale solo para esta página */ }
    document.documentElement.dataset.adultos = 'ok';
  });
}

function activarFormulariosCuenta() {
  document.querySelectorAll('select[data-default]').forEach((select) => {
    if (select.dataset.default) select.value = select.dataset.default;
  });
  document.addEventListener('submit', (evento) => {
    const mensaje = evento.target.dataset?.confirmar;
    if (mensaje && !window.confirm(mensaje)) evento.preventDefault();
  });
}

// «Algo como…»: eliges un libro de la búsqueda predictiva y te lleva a su demografía filtrada por sus subgéneros.
// Los datos del libro llegan por Section Rendering (sections/algo-como) y el conteo, por sections/algo-como-cuenta.
class AlgoComo extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.lista = this.querySelector('[role="listbox"]');
    this.resultado = this.querySelector('[data-algo-resultado]');
    if (!this.input || !this.lista || !this.resultado) return;
    this.temporizador = 0;
    this.input.addEventListener('input', () => {
      clearTimeout(this.temporizador);
      this.temporizador = setTimeout(() => this.sugerir(), 200);
    });
    this.input.addEventListener('keydown', (evento) => this.teclado(evento));
    this.lista.addEventListener('click', (evento) => {
      const opcion = evento.target.closest('[role="option"][data-url]');
      if (opcion) this.elegir(opcion);
    });
    this.addEventListener('focusout', (evento) => { if (!this.contains(evento.relatedTarget)) this.cerrar(); });
    this.querySelectorAll('[data-algo-ejemplo]').forEach((boton) => boton.addEventListener('click', async () => {
      this.input.value = boton.dataset.algoEjemplo;
      await this.sugerir();
      if (this.opciones?.length) this.elegir(this.opciones[0]);
    }));
    // Desde el buscador de la cabecera («como Berserk») llega el título en ?algo=
    const pedido = new URLSearchParams(location.search).get('algo');
    if (pedido) {
      this.input.value = pedido;
      this.sugerir();
    }
  }

  async sugerir() {
    const termino = this.input.value.trim();
    if (termino.length < 2) return this.cerrar();
    this.peticion?.abort();
    this.peticion = new AbortController();
    const parametros = new URLSearchParams({ q: termino, 'resources[type]': 'product', 'resources[limit]': '6' });
    try {
      const datos = await (await fetch(`${this.dataset.sugerencias}.json?${parametros}`, { signal: this.peticion.signal })).json();
      const libros = datos.resources?.results?.products ?? [];
      const opciones = libros.map((libro, i) => {
        const opcion = Object.assign(document.createElement('li'), { className: 'algo__opcion', id: `${this.lista.id}-${i}` });
        opcion.setAttribute('role', 'option');
        opcion.setAttribute('aria-selected', 'false');
        opcion.dataset.url = libro.url.split('?')[0];
        const imagen = libro.featured_image?.url ?? libro.image;
        if (imagen) opcion.append(Object.assign(document.createElement('img'), { src: imagen, alt: '', loading: 'lazy', width: 32, height: 48 }));
        opcion.append(Object.assign(document.createElement('span'), { textContent: libro.title }));
        return opcion;
      });
      if (!opciones.length) {
        const vacia = Object.assign(document.createElement('li'), { className: 'algo__opcion', textContent: this.dataset.textoSinOpciones });
        vacia.setAttribute('role', 'option');
        vacia.setAttribute('aria-disabled', 'true');
        opciones.push(vacia);
      }
      this.lista.replaceChildren(...opciones);
      this.opciones = [...this.lista.querySelectorAll('[data-url]')];
      this.activa = -1;
      this.abrir();
    } catch (error) {
      if (error.name !== 'AbortError') this.cerrar();
    }
  }

  abrir() {
    this.lista.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  }

  cerrar() {
    this.lista.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
  }

  teclado(evento) {
    if (this.lista.hidden || !this.opciones?.length) return;
    if (evento.key === 'ArrowDown' || evento.key === 'ArrowUp') {
      evento.preventDefault();
      const paso = evento.key === 'ArrowDown' ? 1 : -1;
      this.activa = (this.activa + paso + this.opciones.length) % this.opciones.length;
      this.opciones.forEach((opcion, i) => opcion.setAttribute('aria-selected', String(i === this.activa)));
      this.input.setAttribute('aria-activedescendant', this.opciones[this.activa].id);
      this.opciones[this.activa].scrollIntoView({ block: 'nearest' });
    } else if (evento.key === 'Enter' && this.activa >= 0) {
      evento.preventDefault();
      this.elegir(this.opciones[this.activa]);
    } else if (evento.key === 'Escape') {
      this.cerrar();
    }
  }

  async contar(url) {
    const consulta = new URL(url);
    consulta.searchParams.set('section_id', 'algo-como-cuenta');
    const html = await (await fetch(consulta)).text();
    return Number(new DOMParser().parseFromString(html, 'text/html').querySelector('[data-algo-cuenta]')?.dataset.algoCuenta ?? 0);
  }

  async elegir(opcion) {
    this.input.value = opcion.textContent.trim();
    this.cerrar();
    this.resultado.textContent = this.dataset.textoBuscarParecidos;
    try {
      const html = await (await fetch(`${opcion.dataset.url}?section_id=algo-como`)).text();
      const datos = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-algo-datos]');
      const subgeneros = (datos?.dataset.subgeneros ?? '').split(';').filter(Boolean).map((s) => {
        const [id, nombre] = s.split('|');
        return { id, nombre };
      });
      const base = datos?.dataset.demografia ? this.dataset[datos.dataset.demografia] : '';
      let destino = null;
      let cuenta = null;
      let usados = [];
      if (base) {
        // Dos subgéneros afinan más; si quedan muy pocos tomos, se prueba con uno y después con ninguno.
        for (const cantidad of [2, 1, 0]) {
          const url = new URL(base, location.origin);
          subgeneros.slice(0, cantidad).forEach((s) => url.searchParams.append('filter.p.m.libro.subgeneros', `gid://shopify/Metaobject/${s.id}`));
          const n = await this.contar(url);
          if (n >= 6 || cantidad === 0) {
            [destino, cuenta, usados] = [url, n, subgeneros.slice(0, cantidad)];
            break;
          }
        }
      } else if (subgeneros.length) {
        destino = new URL(this.dataset.busqueda, location.origin);
        destino.searchParams.set('q', subgeneros[0].nombre);
        destino.searchParams.set('type', 'product');
        usados = subgeneros.slice(0, 1);
      }
      if (!destino) {
        this.resultado.textContent = this.dataset.textoSinDatos;
        return;
      }
      const pistas = Object.assign(document.createElement('p'), {
        className: 'algo__pistas',
        textContent: [datos.dataset.demografiaNombre, ...usados.map((s) => s.nombre)].filter(Boolean).join(' · '),
      });
      const enlace = Object.assign(document.createElement('a'), { className: 'boton', href: `${destino.pathname}${destino.search}` });
      enlace.textContent = cuenta === null ? this.dataset.textoVer : this.dataset.textoCuenta.replace('__n__', cuenta.toLocaleString('es-CL'));
      this.resultado.replaceChildren(pistas, enlace);
    } catch {
      this.resultado.textContent = this.dataset.textoSinDatos;
    }
  }
}
customElements.define('algo-como', AlgoComo);

// Color de un lomo: el promedio de los píxeles más vivos de la portada, oscurecido hasta que el número se lea (AA).
function colorDePortada(img) {
  colorDePortada.lienzo ??= Object.assign(document.createElement('canvas'), { width: 12, height: 18 });
  colorDePortada.ctx ??= colorDePortada.lienzo.getContext('2d', { willReadFrequently: true });
  const ctx = colorDePortada.ctx;
  ctx.drawImage(img, 0, 0, 12, 18);
  const d = ctx.getImageData(0, 0, 12, 18).data;
  const pixeles = [];
  for (let i = 0; i < d.length; i += 4) {
    const max = Math.max(d[i], d[i + 1], d[i + 2]);
    const min = Math.min(d[i], d[i + 1], d[i + 2]);
    pixeles.push({ c: [d[i], d[i + 1], d[i + 2]], v: max ? ((max - min) / max) * (max / 255) : 0 });
  }
  const vivos = pixeles.sort((a, b) => b.v - a.v).slice(0, Math.ceil(pixeles.length * 0.3));
  let color = [0, 1, 2].map((k) => vivos.reduce((suma, p) => suma + p.c[k], 0) / vivos.length);
  const luz = (c) => c.map((v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; }).reduce((suma, v, k) => suma + v * [0.2126, 0.7152, 0.0722][k], 0);
  let texto = '#fff';
  if ((luz(color) + 0.05) / 0.057 >= 7) texto = '#15130f';
  else while (1.05 / (luz(color) + 0.05) < 4.6) color = color.map((v) => v * 0.9);
  return { fondo: `rgb(${color.map(Math.round).join(' ')})`, texto };
}

// «Completa tu serie»: marcas los tomos que tienes (se guarda en este navegador, junto con los que ya compraste) y
// agrega de una vez los que faltan y están disponibles.
class CompletaSerie extends HTMLElement {
  connectedCallback() {
    // Las portadas que se abren en cada lomo se cargan recién cuando el cursor o el foco llegan al estante
    const despertar = () => this.querySelectorAll('.serie__portada img[data-src]').forEach((img) => {
      img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      delete img.dataset.src;
    });
    this.addEventListener('pointerenter', despertar, { once: true });
    this.addEventListener('focusin', despertar, { once: true });
    // En series largas el estante abre centrado en el tomo de la ficha (solo en horizontal: la página no se mueve)
    requestAnimationFrame(() => {
      const estante = this.querySelector('.serie__tomos'), actual = this.querySelector('.serie__tomo--actual');
      if (!estante || !actual) return;
      const e = estante.getBoundingClientRect(), a = actual.getBoundingClientRect();
      estante.scrollLeft += a.left - e.left - (e.width - a.width) / 2;
    });
    this.clave = `comixstore:tengo:${this.dataset.serie}`;
    this.tomos = [...this.querySelectorAll('[data-producto]')];
    this.marcar = this.querySelector('[data-completa-marcar]');
    this.agregar = this.querySelector('[data-completa-agregar]');
    this.resumen = this.querySelector('[data-completa-resumen]');
    if (!this.tomos.length || !this.marcar) return;
    this.tengo = new Set([...this.leer(), ...this.tomos.filter((t) => t.classList.contains('serie__tomo--tenido')).map((t) => t.dataset.producto)]);
    this.marcar.hidden = false;
    this.marcar.addEventListener('click', () => this.alternarModo());
    this.agregar.addEventListener('click', () => this.agregarFaltantes());
    this.resaltar = this.querySelector('[data-completa-resaltar]');
    this.resaltar?.addEventListener('click', () => {
      const activo = this.resaltar.getAttribute('aria-pressed') !== 'true';
      this.resaltar.setAttribute('aria-pressed', String(activo));
      this.querySelector('.serie__tomos')?.toggleAttribute('data-resaltar', activo);
    });
    this.pintar();
    this.pintarLomos();
  }

  // Cada lomo toma el color de una miniatura de su portada (16 px) cuando el estante está por verse, y solo después de
  // que la página terminó de cargar: así las 100 y tantas portadas de una serie larga no compiten con la principal (LCP).
  pintarLomos() {
    const pintar = (lomo) => {
      const img = new Image();
      img.addEventListener('load', () => {
        try {
          const { fondo, texto } = colorDePortada(img);
          lomo.style.setProperty('--lomo', fondo);
          lomo.style.setProperty('--lomo-texto', texto);
        } catch { /* portada de otro dominio: queda el color base */ }
      }, { once: true });
      img.src = lomo.dataset.muestra;
    };
    const empezar = () => {
      const lomos = () => this.querySelectorAll('.serie__lomo[data-muestra]').forEach(pintar);
      if (document.readyState === 'complete') lomos(); else addEventListener('load', lomos, { once: true });
    };
    if (!('IntersectionObserver' in window)) { empezar(); return; }
    new IntersectionObserver((entradas, observador) => {
      if (!entradas.some((e) => e.isIntersecting)) return;
      observador.disconnect();
      empezar();
    }, { rootMargin: '400px 0px' }).observe(this);
  }

  leer() {
    try { return JSON.parse(localStorage.getItem(this.clave) || '[]'); } catch { return []; }
  }

  guardar() {
    try { localStorage.setItem(this.clave, JSON.stringify([...this.tengo])); } catch { /* sin almacenamiento */ }
  }

  faltantes() {
    return this.tomos.filter((t) => !this.tengo.has(t.dataset.producto) && t.hasAttribute('data-disponible') && !t.hasAttribute('data-especial'));
  }

  alternarModo() {
    const marcando = this.marcar.getAttribute('aria-pressed') !== 'true';
    this.marcar.setAttribute('aria-pressed', String(marcando));
    this.marcar.textContent = marcando ? this.dataset.textoListo : this.dataset.textoMarcar;
    this.querySelector('[data-completa-nota]')?.toggleAttribute('hidden', !marcando);
    this.tomos.forEach((tomo) => {
      tomo.querySelector('.serie__marcar')?.remove();
      if (!marcando) return;
      const boton = Object.assign(document.createElement('button'), { type: 'button', className: 'serie__marcar' });
      boton.setAttribute('aria-label', this.dataset.textoTengo.replace('__n__', tomo.dataset.numero || '·'));
      boton.setAttribute('aria-pressed', String(this.tengo.has(tomo.dataset.producto)));
      boton.addEventListener('click', () => {
        const id = tomo.dataset.producto;
        if (this.tengo.has(id)) this.tengo.delete(id); else this.tengo.add(id);
        boton.setAttribute('aria-pressed', String(this.tengo.has(id)));
        this.guardar();
        this.pintar();
      });
      tomo.append(boton);
    });
    if (marcando) this.tomos[0]?.querySelector('.serie__marcar')?.focus();
  }

  pintar() {
    const faltan = this.faltantes();
    this.tomos.forEach((t) => {
      t.classList.toggle('serie__tomo--tenido', this.tengo.has(t.dataset.producto));
      t.classList.toggle('serie__tomo--falta', this.tengo.size > 0 && faltan.includes(t));
    });
    if (this.resaltar) this.resaltar.hidden = this.tengo.size === 0 || faltan.length === 0;
    const caja = this.querySelector('[data-completa]');
    if (!caja) return;
    caja.hidden = this.tengo.size === 0;
    this.querySelector('[data-completa-avance]')?.style.setProperty('--avance', (this.tengo.size / this.tomos.length).toFixed(3));
    this.resumen.textContent = this.dataset.textoResumen.replace('__tengo__', this.tengo.size).replace('__faltan__', faltan.length);
    this.agregar.hidden = faltan.length === 0 || faltan.length > 30;
    this.agregar.textContent = this.dataset.textoAgregar.replace('__n__', faltan.length);
  }

  async agregarFaltantes() {
    const faltan = this.faltantes();
    if (!faltan.length) return;
    this.agregar.setAttribute('aria-busy', 'true');
    volarALaBolsa(faltan[0].querySelector('img'));
    try {
      const respuesta = await carrito.pedir(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, {
        items: faltan.map((t) => ({ id: Number(t.dataset.variante), quantity: 1 })),
        sections: carrito.seccionesPedidas(), sections_url: location.pathname,
      });
      carrito.aplicarSecciones(respuesta.sections);
      await carrito.actualizarBurbuja();
      carrito.abrir();
    } catch (error) {
      window.alert(error.message);
    } finally {
      this.agregar.removeAttribute('aria-busy');
    }
  }
}
customElements.define('completa-serie', CompletaSerie);

// Recorrido de la primera visita: un diálogo no modal que avanza por pasos y señala cada parte de la página.
class RecorridoGuia extends HTMLElement {
  connectedCallback() {
    this.dialogo = this.querySelector('dialog');
    this.pasos = [...this.querySelectorAll('[data-recorrido-paso]')];
    if (!this.dialogo || !this.pasos.length || this.hasAttribute('data-editor')) return;
    try { if (localStorage.getItem(this.dataset.clave)) return; } catch { return; }
    this.querySelector('[data-recorrido-saltar]').addEventListener('click', () => this.terminar());
    this.querySelector('[data-recorrido-siguiente]').addEventListener('click', () => {
      if (this.indice < this.pasos.length - 1) this.mostrar(this.indice + 1); else this.terminar();
    });
    this.dialogo.addEventListener('keydown', (evento) => { if (evento.key === 'Escape') this.terminar(); });
    // Después de que la página cargó, para no competir con la portada principal.
    window.addEventListener('load', () => setTimeout(() => this.mostrar(0), 1200), { once: true });
  }

  mostrar(indice) {
    this.indice = indice;
    this.foco?.classList.remove('recorrido-foco');
    this.pasos.forEach((paso, i) => { paso.hidden = i !== indice; });
    const paso = this.pasos[indice];
    this.querySelector('[data-recorrido-cuenta]').textContent = this.dataset.textoPaso.replace('__n__', indice + 1).replace('__total__', this.pasos.length);
    this.querySelector('[data-recorrido-siguiente]').textContent = indice === this.pasos.length - 1 ? this.dataset.textoListo : this.dataset.textoSiguiente;
    this.dialogo.setAttribute('aria-labelledby', paso.querySelector('h2')?.id ?? '');
    this.foco = paso.dataset.objetivo ? document.querySelector(paso.dataset.objetivo) : null;
    if (this.foco) {
      this.foco.classList.add('recorrido-foco');
      this.foco.scrollIntoView({ block: 'center', behavior: movimientoReducido.matches ? 'auto' : 'smooth' });
    }
    if (!this.dialogo.open) this.dialogo.show();
    paso.querySelector('h2')?.focus({ preventScroll: true });
  }

  terminar() {
    try { localStorage.setItem(this.dataset.clave, '1'); } catch { /* sin almacenamiento */ }
    this.foco?.classList.remove('recorrido-foco');
    if (this.dialogo.open) this.dialogo.close();
  }
}
customElements.define('recorrido-guia', RecorridoGuia);

class PestanasSeccion extends HTMLElement {
  connectedCallback() {
    this.pestanas = [...this.querySelectorAll('[role="tab"]')];
    this.pestanas.forEach((pestana) => pestana.addEventListener('click', () => this.mostrar(pestana)));
    this.addEventListener('keydown', (evento) => {
      const i = this.pestanas.indexOf(document.activeElement);
      if (i < 0 || !['ArrowLeft', 'ArrowRight'].includes(evento.key)) return;
      const siguiente = this.pestanas[(i + (evento.key === 'ArrowRight' ? 1 : -1) + this.pestanas.length) % this.pestanas.length];
      siguiente.focus();
      this.mostrar(siguiente);
    });
  }

  mostrar(elegida) {
    cambiarConTransicion(() => {
      this.pestanas.forEach((pestana) => {
        const activa = pestana === elegida;
        pestana.setAttribute('aria-selected', String(activa));
        pestana.tabIndex = activa ? 0 : -1;
        const panel = document.getElementById(pestana.getAttribute('aria-controls'));
        if (panel) panel.hidden = !activa;
      });
    });
  }
}
customElements.define('pestanas-seccion', PestanasSeccion);

activarInclinacion();
activarTransicionPortada();
activarFormulariosCuenta();
activarAvisoAdultos();
activarSeguirSerie();
activarResultados();
activarCarrito();
activarRecomendaciones();
